import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../../config';
import AccountingWorkspace from './AccountingWorkspace';
import ReceiptGenerator from './ReceiptGenerator';
import * as XLSX from 'xlsx';




export default function Payments() {
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState('');
  const [activeSection, setActiveSection] = useState('fees');
  
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [feeFile, setFeeFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleFile, setScheduleFile] = useState(null);
  const [uploadingSchedule, setUploadingSchedule] = useState(false);
  const [loadingBatches, setLoadingBatches] = useState(true);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [histStudent, setHistStudent] = useState(null);

  const [showManualModal, setShowManualModal] = useState(false);
  const [manualStudent, setManualStudent] = useState(null);
  const [manualAmount, setManualAmount] = useState('');
  const [manualMethod, setManualMethod] = useState('CASH');
  const [recordingManual, setRecordingManual] = useState(false);
  const [showReceiptGenerator, setShowReceiptGenerator] = useState(false);
  const [receiptToEdit, setReceiptToEdit] = useState(null);

  const [standaloneReceipts, setStandaloneReceipts] = useState([]);
  const [loadingReceipts, setLoadingReceipts] = useState(false);

  const [receiptStartDate, setReceiptStartDate] = useState('');
  const [receiptEndDate, setReceiptEndDate] = useState('');
  const [instituteInfo, setInstituteInfo] = useState({ name: '', phone: '' });


  useEffect(() => {
    fetchBatches();
    fetchStudents();
    fetchStandaloneReceipts();
    fetchInstituteInfo();
  }, []);

  const fetchInstituteInfo = () => {
    axios.get(`${API_BASE_URL}/api/theme`)
      .then(res => {
        setInstituteInfo({
          name: res.data.schoolName || 'IBS Institute',
          phone: res.data.institutePhone || '9316068310'
        });
      })
      .catch(err => console.error("Failed to fetch institute info:", err));
  };

  const fetchStandaloneReceipts = () => {
    setLoadingReceipts(true);
    const user = JSON.parse(localStorage.getItem('user'));
    const tenantId = user?.tenantEmail || 'PENSENSE_DEFAULT';
    
    axios.get(`${API_BASE_URL}/api/payments/standalone-receipts`, {
      headers: { 'X-Tenant-ID': tenantId }
    })
      .then(res => {
        const sorted = (res.data || []).sort((a, b) => {
          const dateA = a.receiptDate || '';
          const dateB = b.receiptDate || '';
          if (dateA !== dateB) {
            return dateB.localeCompare(dateA);
          }
          return (b.id || 0) - (a.id || 0);
        });
        setStandaloneReceipts(sorted);
      })
      .catch(err => console.error("Failed to fetch receipts:", err))
      .finally(() => setLoadingReceipts(false));
  };

  const fetchBatches = () => {
    setLoadingBatches(true);
    axios.get(API_BASE_URL + '/api/batches?t=' + Date.now())
      .then(res => setBatches(res.data))
      .catch(console.error)
      .finally(() => setLoadingBatches(false));
  };

  const fetchStudents = () => {
    axios.get(API_BASE_URL + '/api/students?t=' + Date.now())
      .then(res => {
        if (Array.isArray(res.data)) {
          setStudents(res.data);
        } else {
          console.error("API did not return an array for students:", res.data);
          setStudents([]);
        }
      })
      .catch(err => {
        console.error("Failed to fetch students:", err);
        setStudents([]);
      });
  };

  const handleUploadFeeStatus = (e) => {
    e.preventDefault();
    if (!feeFile) return;
    setUploading(true);
    const formData = new FormData();
    formData.append('file', feeFile);
    axios.post(API_BASE_URL + '/api/students/fee/upload', formData)
      .then(res => {
        toast(res.data?.message || "Fee schedule successfully processed!");
        setShowUploadModal(false);
        setFeeFile(null);
        fetchStudents(); 
      })
      .catch(err => {
        const msg = err.response?.data ? (typeof err.response.data === 'string' ? err.response.data : JSON.stringify(err.response.data)) : err.message;
        toast("Failed to upload Fee Status: " + msg);
      })
      .finally(() => setUploading(false));
  };

  const handleSelectAll = (e) => {
    const list = students.filter(s => selectedBatch === 'ALL' ? true : s.batchIdStr === selectedBatch);
    if (e.target.checked) {
      setSelectedStudents(list.map(s => s.id));
    } else {
      setSelectedStudents([]);
    }
  };

  const handleSelectStudent = (id) => {
    setSelectedStudents(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const handleFetchHistory = (student) => {
    setHistStudent(student);
    setShowHistoryModal(true);
    setHistoryLoading(true);
    axios.get(`${API_BASE_URL}/api/students/email/${student.email}/fee-records`)
      .then(res => setPaymentHistory(res.data))
      .catch(err => toast("Failed to load payment history: " + err.message))
      .finally(() => setHistoryLoading(false));
  };

  const handleUploadSchedule = (e) => {
    e.preventDefault();
    if (selectedStudents.length === 0) return;
    setUploadingSchedule(true);
    const formData = new FormData();
    formData.append('studentIds', selectedStudents.join(','));
    formData.append('totalFee', '0'); // Backend will calculate from installments if 0
    if (scheduleFile) formData.append('file', scheduleFile);

    axios.post(API_BASE_URL + '/api/students/fee-schedule/upload-multi', formData)
      .then(() => {
        toast("Successfully applied multi-student fee schedules!");
        setShowScheduleModal(false);
        setSelectedStudents([]);
        setScheduleFile(null);
        fetchStudents();
      })
      .catch(err => toast("Failed to apply schedule: " + err.message))
      .finally(() => setUploadingSchedule(false));
  };

  const handleManualPayment = (e) => {
    e.preventDefault();
    if (!manualStudent || !manualAmount) return;
    setRecordingManual(true);
    axios.post(`${API_BASE_URL}/api/payments/record-manual`, {
      studentEmail: manualStudent.email,
      amount: manualAmount,
      paymentMethod: manualMethod
    })
    .then(res => {
      toast("Payment recorded successfully!");
      setShowManualModal(false);
      setManualAmount('');
      fetchStudents();
    })
    .catch(err => {
      toast.error("Failed to record manual payment: " + (err.response?.data?.message || err.message));
    })
    .finally(() => setRecordingManual(false));
  };

  const [issuingInvoiceId, setIssuingInvoiceId] = useState(null);

  const handleIssueInvoice = (recordId) => {
    setIssuingInvoiceId(recordId);
    axios.get(`${API_BASE_URL}/api/payments/generate-invoice-for-record/${recordId}`)
      .then(res => {
        if (res.data.invoiceId) {
          const downloadUrl = `${API_BASE_URL}/api/payments/invoice/download/${res.data.invoiceId}`;
          // Fetch the file explicitly to ensure auth/tenant headers are passed
          const user = JSON.parse(localStorage.getItem('user'));
          const tenantId = user?.tenantEmail || 'PENSENSE_DEFAULT';

          axios.get(downloadUrl, { 
            responseType: 'blob',
            headers: { 'X-Tenant-ID': tenantId }
          })
            .then(blobRes => {
              const url = window.URL.createObjectURL(new Blob([blobRes.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `Invoice_${res.data.invoiceId}.pdf`);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
              toast.success("Invoice downloaded!");
            })
            .catch(err => {
              console.error("PDF Fetch error:", err);
              toast.error("Failed to fetch invoice PDF file: " + (err.response?.status === 404 ? "File not found" : (err.response?.data?.message || err.message)));
            });
        }
      })
      .catch(err => toast.error("Failed to generate invoice: " + (err.response?.data?.message || err.message)))
      .finally(() => setIssuingInvoiceId(null));
  };

  const handleExportExcel = () => {
    const filtered = standaloneReceipts.filter(r => {
      if (!receiptStartDate && !receiptEndDate) return true;
      const rDate = new Date(r.receiptDate);
      const start = receiptStartDate ? new Date(receiptStartDate) : new Date(0);
      const end = receiptEndDate ? new Date(receiptEndDate) : new Date();
      end.setHours(23, 59, 59, 999);
      return rDate >= start && rDate <= end;
    });

    const totalSales = filtered.reduce((acc, curr) => acc + (curr.totalAmount || 0), 0);

    const data = [
      [instituteInfo.name],
      [`Phone No: ${instituteInfo.phone}`],
      [],
      ['Sales Summary Report'],
      [`Dated: ${receiptStartDate || 'All'} - ${receiptEndDate || 'Present'}`],
      [instituteInfo.name],
      [`Phone No: ${instituteInfo.phone}`],
      [`Total Sales: ₹${totalSales.toLocaleString('en-IN')}`],
      [],
      ['Invoice No', 'Invoice Date', 'Contact Name', 'Amount', 'Remaining Amount', 'Invoice Status']
    ];

    filtered.forEach(r => {
      data.push([
        r.receiptNumber,
        r.receiptDate,
        r.clientName,
        r.totalAmount,
        0, // Remaining Amount
        'Paid' // Invoice Status
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sales Summary");
    XLSX.writeFile(wb, `Sales_Summary_${new Date().toISOString().split('T')[0]}.xlsx`);
  };



  return (
    <div className="max-w-[1600px] mx-auto space-y-8 pb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="inline-flex rounded-2xl border border-slate-800 bg-slate-900/60 p-1 shadow-xl shadow-slate-950/20">
        <button
          type="button"
          onClick={() => setActiveSection('fees')}
          className={`rounded-xl px-5 py-2.5 text-sm font-semibold transition-all ${activeSection === 'fees' ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20' : 'text-slate-300 hover:bg-slate-800'}`}
        >
          Fee Operations
        </button>
        <button
          type="button"
          onClick={() => setActiveSection('accounting')}
          className={`rounded-xl px-5 py-2.5 text-sm font-semibold transition-all ${activeSection === 'accounting' ? 'bg-cyan-500 text-slate-950 shadow-lg shadow-cyan-500/20' : 'text-slate-300 hover:bg-slate-800'}`}
        >
          Accounting
        </button>
        <button
          type="button"
          onClick={() => setActiveSection('quick-receipts')}
          className={`rounded-xl px-5 py-2.5 text-sm font-semibold transition-all ${activeSection === 'quick-receipts' ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/20' : 'text-slate-300 hover:bg-slate-800'}`}
        >
          Quick Receipts
        </button>
      </div>

      {activeSection === 'fees' ? (
        <>
      {/* Header and Controls */}
      <div className="relative rounded-3xl bg-gradient-to-r from-emerald-900/40 via-teal-900/20 to-slate-900 border border-emerald-500/20 p-8 overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 blur-[80px] rounded-full"></div>
        
        <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex-1 max-w-2xl">
            <h1 className="text-3xl font-bold tracking-tight text-white mb-2 text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
              Fee Management Center
            </h1>
            <p className="text-emerald-100/70 mb-6">Track and update student tuition statuses centrally across all your batches.</p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <select 
                className="bg-slate-900/80 border border-emerald-500/20 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500 transition-colors shadow-inner w-full sm:w-80 disabled:opacity-50 disabled:cursor-wait"
                value={selectedBatch}
                onChange={e => {
                  setSelectedBatch(e.target.value);
                  setSelectedStudents([]);
                }}
                disabled={loadingBatches}
              >
                <option value="">{loadingBatches ? "Loading Datasets..." : "Select a Batch to View..."}</option>
                <option value="ALL">All Enrolled Students (Master List)</option>
                {batches.map(b => (
                  <option key={b.id} value={b.batchIdStr}>{b.name} ({b.batchIdStr})</option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="flex flex-col items-end gap-3">
             <button onClick={() => setShowUploadModal(true)} className="px-5 py-2.5 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-medium shadow-lg shadow-emerald-500/20 transition-all flex items-center gap-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                Upload Excel Sheet
             </button>
             {/* Quick Receipt button removed from here */}

          </div>
        </div>
      </div>

      {/* Upload Modal */}
      {showUploadModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 backdrop-blur-sm px-4">
          <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 md:p-8 w-full max-w-md shadow-2xl relative animate-in zoom-in-95 duration-200">
            <div className="flex justify-between items-start mb-2">
              <h2 className="text-xl font-bold text-white">Upload Collected Fees</h2>
              <a href="/Sample_Collected_Fees.csv" download className="text-xs text-emerald-400 hover:text-emerald-300 flex items-center gap-1.5 bg-emerald-500/10 px-3 py-1.5 rounded-lg border border-emerald-500/20 hover:border-emerald-500/40 transition-all shadow-sm">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                Sample Format
              </a>
            </div>
            <p className="text-slate-400 text-sm mb-6">Select a CSV or Excel file containing your collected payment amounts.</p>
            
            <form onSubmit={handleUploadFeeStatus} className="space-y-6">
              <div className="relative group">
                <div className="absolute inset-0 bg-emerald-500/10 rounded-2xl border-2 border-dashed border-emerald-500/30 group-hover:border-emerald-500/50 transition-colors"></div>
                <input 
                  type="file" 
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={(e) => setFeeFile(e.target.files[0])}
                  className="relative z-10 w-full h-32 opacity-0 cursor-pointer"
                  required
                />
                <div className="absolute inset-0 pointer-events-none flex flex-col items-center justify-center text-emerald-500">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mb-2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                  <span className="font-medium text-sm">{feeFile ? feeFile.name : 'Click or drop file here'}</span>
                </div>
              </div>
              
              <div className="flex gap-4">
                <button type="button" onClick={() => setShowUploadModal(false)} className="flex-1 py-3 rounded-xl border border-slate-700 font-semibold text-slate-300 hover:bg-slate-800 transition-colors">Cancel</button>
                <button type="submit" disabled={uploading || !feeFile} className="flex-[2] py-3 rounded-xl bg-emerald-500 font-semibold text-white hover:bg-emerald-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-emerald-500/20">
                  {uploading ? 'Processing...' : 'Upload Data'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Grid */}
      {!selectedBatch ? (
        <div className="flex flex-col items-center justify-center min-h-[400px] border-2 border-dashed border-emerald-500/20 rounded-3xl bg-slate-900/20 mt-8 relative overflow-hidden">
           <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-emerald-500/10 blur-[100px] rounded-full"></div>
           <div className="relative z-10 flex flex-col items-center">
             <div className="w-20 h-20 rounded-full bg-slate-800 flex items-center justify-center text-emerald-500/50 mb-6 shadow-inner ring-1 ring-white/5">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
             </div>
             <h3 className="text-2xl font-bold text-slate-300 mb-2">No Batch Selected</h3>
             <p className="text-slate-500 text-center max-w-md">Drop down the Batch selector above to view the real-time fee and tuition statuses of your enrolled students.</p>
           </div>
        </div>
      ) : (
        <div className="rounded-3xl border border-slate-800 bg-slate-900/40 overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-500">
           <div className="p-6 border-b border-slate-800/50 flex flex-col md:flex-row md:items-center justify-between gap-4">
             <div>
               <h2 className="text-lg font-semibold text-slate-200">Enrolled Student Status Grid</h2>
               <div className="flex items-center gap-3 mt-1">
                 <span className="text-sm font-medium text-slate-400 bg-slate-800/50 px-3 py-1 rounded-full border border-slate-700/50">
                    {(Array.isArray(students) ? students : []).filter(s => (selectedBatch === 'ALL' ? true : s.batchIdStr === selectedBatch)).length} Students
                 </span>
                 {selectedStudents.length > 0 && (
                   <span className="text-sm font-bold text-emerald-400 bg-emerald-500/10 px-3 py-1 rounded-full border border-emerald-500/30">
                     {selectedStudents.length} Selected
                   </span>
                 )}
               </div>
             </div>
             
             {selectedStudents.length > 0 && (
               <button 
                 onClick={() => setShowScheduleModal(true)}
                 className="px-5 py-2 rounded-lg bg-indigo-500 hover:bg-indigo-600 text-white font-semibold transition-all flex items-center gap-2 shadow-lg shadow-indigo-500/20"
               >
                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                 Set Target Fee & Schedule Document
               </button>
             )}
           </div>
           <div className="overflow-x-auto">
             <table className="w-full text-left border-collapse">
               <thead>
                 <tr className="text-xs uppercase tracking-wider text-slate-500 bg-slate-950/50 border-b border-slate-800">
                   <th className="p-5 font-semibold w-12">
                     <input 
                       type="checkbox" 
                       onChange={handleSelectAll} 
                       checked={(Array.isArray(students) ? students : []).filter(s => (selectedBatch === 'ALL' ? true : s.batchIdStr === selectedBatch)).length > 0 && selectedStudents.length === (Array.isArray(students) ? students : []).filter(s => (selectedBatch === 'ALL' ? true : s.batchIdStr === selectedBatch)).length}
                       className="w-4 h-4 rounded border-slate-700 text-emerald-500 focus:ring-emerald-500 bg-slate-900/50"
                     />
                   </th>
                   <th className="p-5 font-semibold">Student Email</th>
                   <th className="p-5 font-semibold">Name</th>
                   <th className="p-5 font-semibold">Target Tuition</th>
                   <th className="p-5 font-semibold">Total Paid</th>
                   <th className="p-5 font-semibold">Pending Dues</th>
                   <th className="p-5 font-semibold">Schedule Doc</th>
                   <th className="p-5 font-semibold text-right">Accounting Status</th>
                 </tr>
               </thead>
               <tbody className="divide-y divide-slate-800/50">
                 {(Array.isArray(students) ? students : []).filter(s => (selectedBatch === 'ALL' ? true : s.batchIdStr === selectedBatch)).map(st => {
                   const studentTotal = st.totalFees || 0;
                   const feesPaid = st.feesPaid || 0;
                   const totalDueToDate = st.totalDueToDate || 0;
                   let pending = Math.max(0, totalDueToDate - feesPaid);
                   
                   let totalRemaining = Math.max(0, studentTotal - feesPaid);
                   let status = totalRemaining === 0 ? (studentTotal === 0 ? 'NOT SET' : 'FULLY PAID') : (feesPaid >= totalDueToDate ? 'UP TO DATE' : (feesPaid > 0 ? 'PARTIAL DUE' : 'NO PAYMENTS'));
                   
                   let statusColor = "bg-slate-500/10 text-slate-400 border-slate-500/20";
                   if (status === 'FULLY PAID') statusColor = "bg-emerald-500/10 text-emerald-400 border-emerald-500/20 shadow-[0_0_10px_rgba(16,185,129,0.1)]";
                   if (status === 'NO PAYMENTS' && studentTotal > 0) statusColor = "bg-rose-500/10 text-rose-400 border-rose-500/20 shadow-[0_0_10px_rgba(244,63,94,0.1)]";
                   if (status === 'PARTIAL DUE') statusColor = "bg-amber-500/10 text-amber-400 border-amber-500/20 shadow-[0_0_10px_rgba(251,191,36,0.1)]";
                   
                   return (
                     <tr key={st.id} className="hover:bg-slate-800/20 transition-colors">
                       <td className="p-5">
                         <input 
                           type="checkbox" 
                           checked={selectedStudents.includes(st.id)}
                           onChange={() => handleSelectStudent(st.id)}
                           className="w-4 h-4 rounded border-slate-700 text-emerald-500 focus:ring-emerald-500 bg-slate-900/50"
                         />
                       </td>
                       <td className="p-5 text-sm font-medium text-slate-500">{st.email}</td>
                       <td className="p-5 text-sm font-semibold text-slate-200">{st.name}</td>
                       <td className="p-5 text-sm text-slate-400 font-mono">₹{(studentTotal ?? 0).toLocaleString('en-IN')}</td>
                       <td className="p-5 text-sm font-bold text-emerald-400 font-mono">₹{(feesPaid ?? 0).toLocaleString('en-IN')}</td>
                       <td className="p-5 text-sm font-bold text-rose-400 font-mono">₹{(pending ?? 0).toLocaleString('en-IN')}</td>
                       <td className="p-5 text-sm w-32">
                         {st.feeScheduleFilename ? (
                           <span className="flex items-center gap-1.5 text-[10px] text-indigo-300 bg-indigo-500/10 px-2 py-1 rounded truncate border border-indigo-500/20" title={st.feeScheduleFilename}>
                             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                             <span className="truncate">{st.feeScheduleFilename}</span>
                           </span>
                         ) : (
                           <span className="text-[10px] text-slate-600 block text-center uppercase tracking-widest font-bold">Unmapped</span>
                         )}
                       </td>
                       <td className="p-5 text-right">
                          <div className="flex items-center justify-end gap-3">
                            <span className={`inline-block px-3 py-1 rounded-md text-[11px] font-bold tracking-wider border transition-colors ${statusColor}`}>
                              {status}
                            </span>
                            <button 
                              onClick={() => handleFetchHistory(st)}
                              className="p-1.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-emerald-400 transition-all border border-slate-700"
                              title="View Payment History"
                            >
                               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            </button>
                            <button 
                               onClick={() => { setManualStudent(st); setShowManualModal(true); }}
                               className="p-1.5 rounded-lg bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-400 transition-all border border-emerald-500/20"
                               title="Record Offline Payment & Issue Invoice"
                             >
                               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                             </button>
                          </div>
                        </td>
                     </tr>
                   );
                 })}
                 {(Array.isArray(students) ? students : []).filter(s => (selectedBatch === 'ALL' ? true : s.batchIdStr === selectedBatch)).length === 0 && (
                   <tr>
                     <td colSpan="8" className="p-12 text-center text-slate-500 font-medium tracking-wide">
                        No students are currently enrolled in this active batch.
                     </td>
                   </tr>
                 )}
               </tbody>
             </table>
           </div>
        </div>
      )}

      {/* Target Schedule Setter Modal */}
      {showScheduleModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 backdrop-blur-sm px-4">
          <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 md:p-8 w-full max-w-lg shadow-2xl relative animate-in zoom-in-95 duration-200">
            <div className="flex justify-between items-start mb-2">
              <h2 className="text-xl font-bold text-white">Configure Student Master Fees</h2>
              <a href="/Sample_Fee_Schedule.csv" download className="text-[10px] text-indigo-400 hover:text-indigo-300 flex items-center gap-1.5 bg-indigo-500/10 px-2.5 py-1.5 rounded-lg border border-indigo-500/20 hover:border-indigo-500/40 transition-all shadow-sm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                Sample Format
              </a>
            </div>
            <p className="text-slate-400 text-sm mb-6">Assigning customized Tuition Targets to <span className="text-indigo-400 font-bold">{selectedStudents.length} selected students</span>.</p>
            
            <form onSubmit={handleUploadSchedule} className="space-y-6">
              
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Detailed Fee Schedule (Required)</label>
                <div className="relative group">
                  <div className="absolute inset-0 bg-indigo-500/10 rounded-2xl border-2 border-dashed border-indigo-500/30 group-hover:border-indigo-500/50 transition-colors"></div>
                  <input 
                    type="file" 
                    required
                    onChange={(e) => setScheduleFile(e.target.files[0])}
                    className="relative z-10 w-full h-32 opacity-0 cursor-pointer"
                  />
                  <div className="absolute inset-0 pointer-events-none flex flex-col items-center justify-center text-indigo-400">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mb-2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                    <span className="font-medium text-sm">{scheduleFile ? scheduleFile.name : 'Click or drop schedule.csv here'}</span>
                  </div>
                </div>
              </div>
              
              <div className="flex gap-4 pt-2">
                <button type="button" onClick={() => setShowScheduleModal(false)} className="flex-1 py-3 rounded-xl border border-slate-700 font-semibold text-slate-300 hover:bg-slate-800 transition-colors">Cancel</button>
                <button type="submit" disabled={uploadingSchedule || !scheduleFile} className="flex-[2] py-3 rounded-xl bg-indigo-500 font-semibold text-white hover:bg-indigo-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-indigo-500/20">
                  {uploadingSchedule ? 'Processing...' : 'Apply Schedule'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Manual Payment Modal */}
      {showManualModal && manualStudent && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 backdrop-blur-sm px-4">
          <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 md:p-8 max-w-lg w-full shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-500/10 blur-3xl rounded-full"></div>
            <div className="relative z-10">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-white">Record Manual Payment</h2>
                <button onClick={() => setShowManualModal(false)} className="text-slate-400 hover:text-white">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
              
              <div className="mb-6 p-4 rounded-2xl bg-emerald-500/5 border border-emerald-500/20">
                <p className="text-sm font-semibold text-emerald-400 mb-1">Student</p>
                <p className="text-lg font-bold text-white">{manualStudent.name}</p>
                <p className="text-xs text-slate-400 mt-1">{manualStudent.batchIdStr}</p>
              </div>

              <form onSubmit={handleManualPayment} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Amount Paid (INR)</label>
                  <input 
                    type="number" 
                    required 
                    value={manualAmount} 
                    onChange={e => setManualAmount(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-emerald-500 transition-colors"
                    placeholder="e.g. 5000"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Payment Method</label>
                  <select 
                    value={manualMethod} 
                    onChange={e => setManualMethod(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-emerald-500 transition-colors"
                  >
                    <option value="CASH">Cash</option>
                    <option value="UPI">UPI (GPay/PhonePe)</option>
                    <option value="BANK_TRANSFER">Bank Transfer</option>
                    <option value="CHEQUE">Cheque</option>
                  </select>
                </div>
                <button 
                  type="submit" 
                  disabled={recordingManual}
                  className="w-full py-3.5 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-bold transition-all shadow-lg shadow-emerald-500/20 disabled:opacity-50"
                >
                  {recordingManual ? 'Recording...' : 'Confirm Payment'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* History Modal */}
      {showHistoryModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm px-4">
           <div className="bg-slate-900 border border-slate-800 rounded-3xl w-full max-w-2xl shadow-2xl relative animate-in zoom-in-95 duration-200 overflow-hidden text-left">
              <div className="p-6 border-b border-slate-800 flex justify-between items-center bg-slate-950/30">
                 <div>
                    <h2 className="text-xl font-bold text-white">Payment Audit Trail</h2>
                    <p className="text-slate-400 text-xs mt-1">Student: <span className="text-emerald-400 font-medium">{histStudent?.name}</span> ({histStudent?.email})</p>
                 </div>
                 <button onClick={() => setShowHistoryModal(false)} className="text-slate-500 hover:text-white transition-colors">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                 </button>
              </div>
              
              <div className="p-6 max-h-[60vh] overflow-y-auto custom-scrollbar">
                 {historyLoading ? (
                    <div className="flex flex-col items-center justify-center py-12">
                       <div className="w-10 h-10 border-4 border-emerald-500/20 border-t-emerald-500 rounded-full animate-spin mb-4"></div>
                       <p className="text-slate-500 text-sm animate-pulse">Retrieving historical records...</p>
                    </div>
                 ) : paymentHistory.length === 0 ? (
                    <div className="text-center py-12">
                       <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-600">
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                       </div>
                       <h3 className="text-slate-300 font-semibold">No Payments Recorded</h3>
                       <p className="text-slate-500 text-sm mt-1">This student has no individual fee records in the database.</p>
                    </div>
                 ) : (
                    <table className="w-full text-left">
                      <thead>
                        <tr className="border-b border-slate-800">
                          <th className="px-5 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-widest">Date</th>
                          <th className="px-5 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-widest">Amount</th>
                          <th className="px-5 py-3 text-right text-[10px] font-bold text-slate-500 uppercase tracking-widest">Action</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-800/50">
                        {paymentHistory.map((rec, idx) => (
                          <tr key={idx} className="hover:bg-slate-800/30 transition-colors">
                            <td className="px-5 py-4 text-xs text-slate-400 font-mono">{rec.paymentDate}</td>
                            <td className="px-5 py-4 text-xs font-bold text-emerald-400 font-mono">₹{rec.amountPaid?.toLocaleString('en-IN')}</td>
                            <td className="px-5 py-4 text-right">
                               <button 
                                 onClick={() => handleIssueInvoice(rec.id)}
                                 disabled={issuingInvoiceId === rec.id}
                                 className="px-3 py-1 rounded bg-slate-800 hover:bg-slate-700 text-[10px] font-bold text-slate-300 border border-slate-700 hover:text-emerald-400 transition-all flex items-center gap-1.5 ml-auto"
                               >
                                 <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                                 {issuingInvoiceId === rec.id ? 'issuing...' : 'Issue Invoice'}
                               </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                 )}
              </div>
              
              <div className="p-6 bg-slate-950/30 border-t border-slate-800 flex justify-between items-center">
                 <div className="text-xs text-slate-500 font-medium">
                    Total Transactions: <span className="text-slate-300">{paymentHistory.length}</span>
                 </div>
                 <button onClick={() => setShowHistoryModal(false)} className="px-6 py-2 rounded-xl bg-slate-800 hover:bg-slate-700 text-white text-sm font-semibold transition-colors">Close Log</button>
              </div>
           </div>
        </div>
      )}

        </>
      ) : activeSection === 'accounting' ? (
        <AccountingWorkspace />
      ) : (
        <div className="space-y-6">
            <div className="relative rounded-3xl bg-slate-900 border border-slate-800 p-8 overflow-hidden">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 relative z-10">
                <div>
                  <h2 className="text-2xl font-bold text-white mb-2">Quick Receipt Report</h2>
                  <p className="text-slate-400 text-sm font-medium">History of all standalone professional receipts issued.</p>
                </div>
                
                <div className="flex flex-wrap items-center gap-4">
                  <div className="flex items-center gap-2">
                    <input 
                      type="date" 
                      value={receiptStartDate}
                      onChange={e => setReceiptStartDate(e.target.value)}
                      className="bg-slate-950 border border-slate-800 rounded-xl px-3 py-2 text-sm text-white focus:outline-none focus:border-blue-500"
                    />
                    <span className="text-slate-500">to</span>
                    <input 
                      type="date" 
                      value={receiptEndDate}
                      onChange={e => setReceiptEndDate(e.target.value)}
                      className="bg-slate-950 border border-slate-800 rounded-xl px-3 py-2 text-sm text-white focus:outline-none focus:border-blue-500"
                    />
                  </div>
                  
                  <button 
                    onClick={handleExportExcel}
                    className="px-5 py-3 rounded-2xl bg-emerald-500 hover:bg-emerald-600 text-white font-bold transition-all shadow-lg shadow-emerald-500/20 flex items-center gap-2 text-sm"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                    Export Excel
                  </button>

                  <button 
                    onClick={() => { setReceiptToEdit(null); setShowReceiptGenerator(true); }} 
                    className="px-6 py-3 rounded-2xl bg-blue-500 hover:bg-blue-600 text-white font-bold transition-all shadow-lg shadow-blue-500/20 flex items-center gap-2 text-sm"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    New Quick Receipt
                  </button>
                </div>
              </div>
            </div>

           <div className="rounded-3xl border border-slate-800 bg-slate-900/40 overflow-hidden">
             {loadingReceipts ? (
               <div className="p-20 text-center text-slate-500 font-medium">Loading receipt history...</div>
             ) : standaloneReceipts.length === 0 ? (
               <div className="p-20 text-center">
                 <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-600">
                   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                 </div>
                 <h3 className="text-slate-300 font-semibold text-lg">No Receipts Found</h3>
                 <p className="text-slate-500 text-sm">You haven't generated any standalone receipts yet.</p>
               </div>
             ) : (
               <div className="overflow-x-auto">
                 <table className="w-full text-left">
                   <thead>
                     <tr className="text-xs uppercase tracking-wider text-slate-500 bg-slate-950/50 border-b border-slate-800">
                       <th className="p-5 font-semibold">Date</th>
                       <th className="p-5 font-semibold">Receipt #</th>
                       <th className="p-5 font-semibold">Client Name</th>
                       <th className="p-5 font-semibold">Amount</th>
                       <th className="p-5 font-semibold">Payment</th>
                       <th className="p-5 font-semibold text-right">Actions</th>
                     </tr>
                   </thead>
                   <tbody className="divide-y divide-slate-800/50">
                     {standaloneReceipts.map(receipt => (
                       <tr key={receipt.id} className="hover:bg-slate-800/20 transition-colors">
                         <td className="p-5 text-sm text-slate-400 font-mono">{receipt.receiptDate}</td>
                         <td className="p-5 text-sm font-bold text-white">{receipt.receiptNumber}</td>
                         <td className="p-5 text-sm font-medium text-slate-200">
                           <div>{receipt.clientName}</div>
                           <div className="text-[10px] text-slate-500 uppercase tracking-wider">{receipt.clientEmail}</div>
                         </td>
                         <td className="p-5 text-sm font-black text-emerald-400 font-mono">₹{receipt.totalAmount?.toLocaleString('en-IN')}</td>
                         <td className="p-5 text-sm text-slate-400 font-bold uppercase tracking-tighter">{receipt.paymentMode}</td>
                         <td className="p-5 text-right">
                           <div className="flex items-center justify-end gap-3">
                             <button 
                               onClick={() => {
                                 const user = JSON.parse(localStorage.getItem('user'));
                                 const tenantId = user?.tenantEmail || 'PENSENSE_DEFAULT';
                                 axios.get(`${API_BASE_URL}/api/payments/standalone-receipts/download/${receipt.id}`, {
                                   responseType: 'blob',
                                   headers: { 'X-Tenant-ID': tenantId }
                                 }).then(res => {
                                   const url = window.URL.createObjectURL(new Blob([res.data]));
                                   const link = document.createElement('a');
                                   link.href = url;
                                   link.setAttribute('download', `Receipt_${receipt.receiptNumber}.pdf`);
                                   document.body.appendChild(link);
                                   link.click();
                                   link.remove();
                                 }).catch(() => toast.error("Download failed"));
                               }}
                               className="p-2 rounded-lg bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-400 transition-all border border-emerald-500/20"
                               title="Download PDF"
                             >
                               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                             </button>
                             <button 
                               onClick={() => { setReceiptToEdit(receipt); setShowReceiptGenerator(true); }}
                               className="p-2 rounded-lg bg-blue-500/10 hover:bg-blue-500/20 text-blue-400 transition-all border border-blue-500/20"
                               title="Edit Receipt"
                             >
                               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                             </button>
                             <button 
                               onClick={() => {
                                 if (window.confirm("Are you sure you want to delete this receipt?")) {
                                   const user = JSON.parse(localStorage.getItem('user'));
                                   const tenantId = user?.tenantEmail || 'PENSENSE_DEFAULT';
                                   axios.delete(`${API_BASE_URL}/api/payments/standalone-receipts/${receipt.id}`, {
                                     headers: { 'X-Tenant-ID': tenantId }
                                   }).then(() => {
                                     toast.success("Receipt deleted");
                                     fetchStandaloneReceipts();
                                   });
                                 }
                               }}
                               className="p-2 rounded-lg bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 transition-all border border-rose-500/20"
                               title="Delete Receipt"
                             >
                               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                             </button>
                           </div>
                         </td>
                       </tr>
                     ))}
                   </tbody>
                 </table>
               </div>
             )}
           </div>
        </div>
      )}

      {showReceiptGenerator && (
        <ReceiptGenerator 
          onClose={() => { setShowReceiptGenerator(false); setReceiptToEdit(null); }} 
          editData={receiptToEdit}
          onRefresh={fetchStandaloneReceipts}
        />
      )}

    </div>
  );
}
